module.exports = __webpack_public_path__ + "media/assets/images/logo-d5f13b6ecdf4898f530d0f58f728eac1.png";